import { MicroMoments } from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  getEmptyContent,
  UserSession
} from '@com-delta-idp/mnx-skymiles-shared';
import { adaptPEMicroMoment } from '../adapters';
import { MultiplePersonalizationEngineResponse } from '../models';
import { StatusTrackerResponse } from '../models/api/tracker.interfaces';
import { TYPE } from '../models/overview.constants';

let invokeFlag = false;
export const checkMicroMomentAndAdapt = (
  personalizationEngine: MultiplePersonalizationEngineResponse,
  profile: UserSession,
  tracker: StatusTrackerResponse,
  featureFlag: boolean
): MicroMoments => {
  if (
    personalizationEngine?.['ng-skymiles:micro-moments-v1']?.parsys
      ?.micromoments &&
    featureFlag
  ) {
    return validateMicroMoment(
      personalizationEngine['ng-skymiles:micro-moments-v1'].parsys.micromoments
        .microMomentType
    )
      ? displayMicroMoment(personalizationEngine, profile, tracker, featureFlag)
      : adaptPEMicroMoment(
          personalizationEngine,
          profile,
          tracker,
          featureFlag
        );
  } else {
    return getEmptyContent<MicroMoments>('', [], true, true);
  }
};

const validateMicroMoment = (microMomentType: string) => {
  return (
    microMomentType === TYPE.AWARD_TRAVEL ||
    microMomentType === TYPE.COMPLETE_PROFILE ||
    microMomentType === TYPE.EARNING_SIMPLER
  );
};

const displayMicroMoment = (
  personalizationEngine: MultiplePersonalizationEngineResponse,
  profile: UserSession,
  tracker: StatusTrackerResponse,
  featureFlag: boolean
) => {
  if (!invokeFlag) {
    const type = personalizationEngine['ng-skymiles:micro-moments-v1'].parsys
      .micromoments?.microMomentType as string;

    const microMomentDisplayCount = Number(localStorage.getItem(type));
    if (validateDisplayCount(type, microMomentDisplayCount)) {
      invokeFlag = true;
      localStorage.setItem(type, (microMomentDisplayCount + 1).toString());
      return adaptPEMicroMoment(
        personalizationEngine,
        profile,
        tracker,
        featureFlag
      );
    } else {
      return getEmptyContent<MicroMoments>('', [], true, true);
    }
  } else {
    return adaptPEMicroMoment(
      personalizationEngine,
      profile,
      tracker,
      featureFlag
    );
  }
};

const validateDisplayCount = (
  type: string,
  microMomentDisplayCount: number
): boolean => {
  return type === TYPE.EARNING_SIMPLER
    ? microMomentDisplayCount < 2
    : microMomentDisplayCount < 3;
};
